import { PhotoEntity, PhotoView } from "./../models/PhotoModel"
import { GooglePickerResult } from "./GooglePickerResult"

const googlePhotoUrlRegexp = /\/s\d+\//

export function transfromToPhotos(result: GooglePickerResult): PhotoEntity[] {
  if (result && result.docs && result.docs.length > 0) {
    const photos: PhotoEntity[] = []
    result.docs.forEach(doc => {
      let photo: PhotoEntity
      doc.thumbnails.forEach(thumb => {
        if (photo) return
        if (
          googlePhotoUrlRegexp.test(thumb.url) &&
          thumb.height &&
          thumb.width
        ) {
          const originalUrl = thumb.url.replace(googlePhotoUrlRegexp, "/s0/")
          photo = new PhotoEntity({
            type: "gphoto",
            id: doc.id,
            originalUrl,
            originalHeight: thumb.height,
            originalWidth: thumb.width
          })
          photos.push(photo)
        }
      })
    })
    return photos
  } else {
    return []
  }
  return []
}

export function transfromToPhotoViews(result: GooglePickerResult): PhotoView[] {
  return transfromToPhotos(result).map(photo => new PhotoView(photo))
}
